import { render } from "./Evaluation.vue?vue&type=template&id=ecf17c16&scoped=true"
import script from "./Evaluation.vue?vue&type=script&lang=js"
export * from "./Evaluation.vue?vue&type=script&lang=js"

import "./Evaluation.vue?vue&type=style&index=0&id=ecf17c16&lang=scss&scoped=true"

import exportComponent from "D:\\ideaWorkSpace\\政泉\\zhengquan\\sqlpj-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecf17c16"]])

export default __exports__